// 定义模块：音乐播放器插件
const MusicPlayer = (function (global) {
    // 插件信息
    const __INFO__ = {
        plugins: "MusicPlayer",
        version: "0.0.1",
        author: "G",
        website: "https://isus.cc"
    };

    // 默认设置
    const defaults = {
        el: "", // 元素 ID
        position: "", // 位置
        buttonImgSrc: "", // 按钮图片源
        htmls: '<audio></audio>' // 音频元素的 HTML
    };

    // 函数定义
    function Player(options) {
        const audio = {
            // 默认设置
            settings: Object.assign({}, defaults, options),
            // 初始化音频状态
            state: false,
            // 初始化首次进入
            isFirstTime: true,
            // 初始化音频盒子
            audioBox: null,
            // 初始化音频标签
            audioTag: null,
            // 初始化音频组件
            init: function () {
                // 获取要附加音频播放器的 DOM 元素
                let audioDom = this.settings.el ? document.getElementById(this.settings.el) : document.body;
                if (!audioDom) audioDom = document.body;

                // 创建一个用于音频播放器的 div 容器
                this.audioBox = document.createElement("div");
                this.audioBox.id = "music-player";
                const boxDefaultStyle = "overflow:hidden;position:absolute;z-index:999;background-size:contain;background-repeat:no-repeat;width:30px;height:30px;cursor:pointer;opacity:0.3;";
                this.audioBox.style = boxDefaultStyle + this.settings.position;
                this.audioBox.innerHTML = this.settings.htmls;
                // 将音频播放器附加到 DOM
                audioDom.appendChild(this.audioBox);

                // 定义动画样式
                const animationStyle = `
                @keyframes musicIconRotate {
                    from {
                        transform: rotate(0deg);
                    }
                    to {
                        transform: rotate(360deg);
                    }
                }
              `;
                // 将动画样式添加到页面中
                const styleElement = document.createElement("style");
                styleElement.innerHTML = animationStyle;
                document.head.appendChild(styleElement);

                // 从容器中获取音频元素
                this.audioTag = this.audioBox.querySelectorAll("audio")[0];

                // 更改播放按钮图像
                if (!this.settings.buttonImgSrc) {
                    // 如果未提供按钮图像，则使用默认图像
                    this.audioBox.style.backgroundImage = `url('data:image/svg+xml;base64,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')`;
                } else {
                    // 如果提供了按钮图像，则使用提供的图像
                    this.audioBox.style.backgroundImage = 'url(' + this.settings.buttonImgSrc + ')';
                }

                // 检测是否在微信浏览器中打开
                if (navigator.userAgent.toLowerCase().match(/micromessenger/i)) {
                    // 在微信环境中监听WeixinJSBridgeReady事件
                    document.addEventListener('WeixinJSBridgeReady', function onBridgeReady() {
                        // 获取网络类型信息
                        WeixinJSBridge.invoke("getNetworkType", {}, function (e) {
                            // 开始播放音频
                            this.play();
                        });
                    });
                }
            },
            // 播放音频
            play: function () {
                // 检查是否提供了音频URL
                if (this.settings.audioUrl) {
                    // 设置音频标签的src属性为提供的音频URL
                    this.audioTag.src = this.settings.audioUrl;
                    // 开始播放音频
                    this.audioTag.play();
                    // 添加旋转动画效果
                    this.audioBox.style.cssText += ";animation: musicIconRotate 1s linear infinite;";
                } else {
                    // 如果没有提供音频URL，则打印错误信息
                    console.error(__INFO__.plugins + '无音乐资源启动失败，请添加音乐资源 audioUrl');
                }
            },
            // 停止音频播放
            stop: function () {
                // 暂停音频播放
                this.audioTag.pause();
                // 清空音频标签的src属性，停止播放当前音频
                this.audioTag.src = "";
                // 移除旋转动画效果
                this.audioBox.style.animation = "";
            }
        };

        // 初始化音频
        audio.init();

        // 返回音频对象，供外部控制播放暂停
        return audio;
    }

    // 导出模块
    return Player;
})(typeof window !== 'undefined' ? window : this);

// 导出模块
export default MusicPlayer;
